import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';
import { Form } from 'react-bootstrap';
import { PiMapPinLineFill } from 'react-icons/pi';
import { BsTelephoneFill } from 'react-icons/bs';
import { SiGmail } from 'react-icons/si';
import { FaFacebook, FaWhatsapp, FaPaperPlane } from 'react-icons/fa';
import { FiChevronRight } from 'react-icons/fi';
import toast, { Toaster } from 'react-hot-toast';
import ContactService from '../../service/ContactService';
import { motion } from 'framer-motion';
import '../../styles/categoryPage.css';

const Contact = () => {
  const [sujet, setSujet] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const ajouter = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    const data = { sujet, email, message };
    try {
      await ContactService.ajouter(data);
      toast.success('Message envoyé avec succès !');
      setSujet("");
      setEmail("");
      setMessage("");
    } catch {
      toast.error("Échec de l'envoi...");
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactItems = [
    {
      icon: <PiMapPinLineFill />,
      title: 'Adresse',
      text: 'Zaouiet Sousse, Sousse, Tunisia, 4000',
      cls: 'hd-contact-pin',
      link: 'https://maps.google.com?q=Zaouiet+Sousse,Sousse,Tunisia'
    },
    {
      icon: <BsTelephoneFill />,
      title: 'Téléphone',
      text: `${process.env.REACT_APP_TEL}`,
      cls: 'hd-contact-phone',
      link: `${process.env.REACT_APP_TEL2}`
    },
    {
      icon: <FaFacebook />,
      title: 'Facebook',
      text: 'Home Deco',
      cls: 'hd-contact-facebook',
      link: `${process.env.REACT_APP_FB}`
    },
    {
      icon: <FaWhatsapp />,
      title: 'WhatsApp',
      text: `${process.env.REACT_APP_TEL}`,
      cls: 'hd-contact-whatsapp',
      link: `${process.env.REACT_APP_WHATSAPP}`
    },
    {
      icon: <SiGmail />,
      title: 'Email',
      text: `${process.env.REACT_APP_GMAIL}`,
      cls: 'hd-contact-gmail',
      link: `${process.env.REACT_APP_GMAIL_URL}`
    },
  ];

  return (
    <div className="hd-contact-page container">
      <Toaster position="top-center" reverseOrder={false} />

      <motion.nav
        className="hd-breadcrumb"
        aria-label="breadcrumb"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <Link to="/">Accueil</Link>
        <FiChevronRight />
        <span>Contact</span>
      </motion.nav>

      <motion.div
        className="hd-contact-header"
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <span className="hd-contact-eyebrow">Une question ?</span>
        <h1>Contactez-nous</h1>
        <p>Nous sommes à votre écoute pour toutes vos questions et demandes</p>
      </motion.div>

      <div className="hd-contact-content">
        <motion.div
          className="hd-contact-info-card"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="hd-contact-info-card-header">
            <h2>Nos coordonnées</h2>
            <p>Plusieurs moyens de nous contacter</p>
          </div>

          <div className="hd-contact-info-grid">
            {contactItems.map((item, i) => (
              <motion.a
                key={i}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`hd-contact-info-item ${item.cls}`}
                whileHover={{ y: -3 }}
                transition={{ duration: 0.2 }}
              >
                <div className="hd-contact-icon">{item.icon}</div>
                <div className="hd-contact-text">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </motion.a>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="hd-contact-form-card"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <div className="hd-contact-form-card-header">
            <h2>Envoyez-nous un message</h2>
            <p>Nous vous répondrons dans les plus brefs délais</p>
          </div>

          <Form onSubmit={ajouter} className="hd-contact-form">
            <Form.Group className="hd-contact-form-group">
              <Form.Label>Sujet</Form.Label>
              <Form.Select
                value={sujet}
                onChange={e => setSujet(e.target.value)}
                required
                className="hd-contact-form-input"
              >
                <option value="" disabled>Sélectionnez un sujet...</option>
                <option>Service client</option>
                <option>Service commandes</option>
                <option>Webmaster</option>
                <option>Autre demande</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="hd-contact-form-group">
              <Form.Label>Votre email</Form.Label>
              <Form.Control
                type="email"
                placeholder="exemple@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="hd-contact-form-input"
              />
            </Form.Group>

            <Form.Group className="hd-contact-form-group">
              <Form.Label>Votre message</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                placeholder="Dites-nous comment nous pouvons vous aider..."
                value={message}
                onChange={e => setMessage(e.target.value)}
                required
                className="hd-contact-form-input"
              />
            </Form.Group>

            <motion.button
              type="submit"
              className="hd-contact-submit-button"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                'Envoi en cours...'
              ) : (
                <>
                  <FaPaperPlane style={{ marginRight: '8px' }} />
                  Envoyer le message
                </>
              )}
            </motion.button>
          </Form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
